import { FormLogoHeader } from '@/components/dialogs/Registration/components/FormHeader/FormLogoHeader';
import type { RegistrationConfig, RegistrationTheme } from '../types';

const LIGHTLE_REG_THEME: RegistrationTheme = {
  bg: '#FFFFFF',
  color: '#9A9CAC',
  headerTextColor: '#000',
  crossBtnColor: '#000',
  borderSelectColor: '#000',
  formMarginBottom: '24px',
  colorLinks: '#25AAD6',
  contentPaddingTop: '12px',
  footer: {
    bg: '#F2F2F4',
    fontColor: '#25AAD6',
  },
  steps: {
    bg: '#F2F2F4',
    inactive: '#C2C2C3',
    active: '#EA5B0C',
    color: '#fff',
  },
  input: {
    bg: '#F2F2F4',
    borderRadius: '12px',
    colorInput: '#131314',
    color: '#9A9CAC',
    height: '48px',
    borderColorFocus: '#00B83E',
  },
  inputLabel: {
    color: '#131314',
  },
  regBanner: {
    marginBottom: '16px',
  },
  countryTooltip: {
    color: '#000',
    textColor: '#000',
  },
  select: {
    bg: '#F2F2F4',
    borderRadius: '12px',
    mobBorderRadius: '24px',
    colorInput: '#131314',
    color: '#8E8E93',
    height: '48px',
    borderActive: '#00B83E',
    activeOptionBg: '#FFFFFF',
    disabledArrowColor: '#131314',
  },
  checkbox: {
    wrapperMargin: 8,
    color: '#000000',
    notActiveBorder: '#8E8E93',
    notActiveBg: '#FFFFFF',
    activeColor: '#00B83E',
  },
};

export const LIGHTLE_CONFIG: RegistrationConfig = {
  head: {
    render: () => <FormLogoHeader logoTheme="black" />,
  },
  input: {
    withInsideLabel: true,
  },
  select: {
    withInsideLabel: true,
  },
  buttons: {
    regButton: {
      colorMode: { secondaryGreenGradient: true },
      isRegistrationSticky: true,
      text: 'common:button.joinNow',
    },
    googleRegButton: {
      colorMode: { blackTransparent: true },
    },
    next: {
      colorMode: { secondaryGreenGradient: true },
    },
    back: {
      colorMode: { blackTransparent: true },
    },
    borderRadius: '12px',
    wrapBorderRadius: '10px',
  },
  checkbox: {
    termsLinkText: 'auth.registration.form.acceptTermsConditionsShort',
  },
  withPayments: false,
  withNavigationOnFirstStep: true,
  styleScheme: LIGHTLE_REG_THEME,
};
